import { Button, Result } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { session } from '@services/session'
import { logout } from '@slice/mainSlice'

const NotFound = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const isAuthenticated = useSelector((state) => state.main.isAuthenticated)
	const prevLocation = sessionStorage.getItem('prevLocation')

	const handleBackHome = () => {
		navigate('/auth')
		session.delete()
		dispatch(logout())
	}

	const content = (
		<div className="flex flex-col items-center justify-center h-screen w-screen bg-[#FFFFFF] overflow-hidden">
			<div className="w-full h-full flex flex-col items-center justify-center p-6 text-center">
				<Result
					title={
						<h1 className="text-9xl font-black bg-gradient-to-br from-[#0A4D68] via-[#0085FF] to-[#0A4D68] bg-clip-text text-transparent animate-float leading-none">
							404
						</h1>
					}
					subTitle={
						<div className="space-y-4 mt-8">
							<p className="text-3xl md:text-5xl text-[#0A4D68] font-bold tracking-tighter">
								{t('notFound')}
							</p>
							<p className="text-gray-400 text-lg md:text-xl max-w-xl mx-auto leading-relaxed">
								{t('notFoundDescription')}
							</p>
						</div>
					}
					extra={
						<Button
							type="primary"
							size="large"
							onClick={handleBackHome}
							className="mt-8 bg-[#0A4D68] hover:bg-[#0085FF] border-none px-12 h-14 rounded-2xl font-bold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-[0_15px_30px_-5px_rgba(10,77_104,0.4)] shadow-lg"
						>
							{t('backToHome')}
						</Button>
					}
				/>
			</div>
		</div>
	)

	return content
}

export default NotFound
